import type { CardType } from "./doc.js";

/** Card types available in the toolbar, in display order. Extending the app = add here + a React component + an exporter. */
export const TOOLBAR_CARDS: { type: CardType; icon: string }[] = [
  { type: "note", icon: "▭" },
  { type: "heading", icon: "T" },
  { type: "image", icon: "▨" },
  { type: "link", icon: "⛓" },
  { type: "board", icon: "▦" },
  { type: "column", icon: "▥" },
  { type: "todo", icon: "☑" },
  { type: "comment", icon: "💬" },
  { type: "line", icon: "↗" },
  { type: "swatch", icon: "●" },
  { type: "sketch", icon: "✎" },
  { type: "annotation", icon: "✍" },
  { type: "table", icon: "▦" },
  { type: "document", icon: "▤" },
  { type: "video", icon: "▶" },
  { type: "audio", icon: "♪" },
  { type: "map", icon: "⌖" },
  { type: "file", icon: "⎘" },
];
